/** @format */
export enum PersonalizedLineAidNumberString {
  NONE = '1',
  STRAIGHT = '2',
  TARGET = '3',
}
